module.exports = __webpack_public_path__ + "resources/img/zoom-ui-examples.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/zoom-ui-examples.jpg
// module id = 1364
// module chunks = 0